<template>
  <div class="bank-bg">
    <van-form @submit="onSubmit">
      <van-field
        v-model="name"
        label="真实姓名"
        placeholder="请输入真实姓名"
        :rules="[{ required: true, message: '请填写真实姓名' }]"
      />
      <van-field
        v-if="!urlName"
        v-model="IDcard"
        label="身份证号"
        placeholder="请输入身份证号"
        maxlength="18"
        :rules="[{ required: true, message: '请填写身份证号' },{validator, message: '身份证号码格式错误！'}]"
      />
      <van-field
        v-model="cardNumber"
        label="收款账号"
        placeholder="请输入您的银行卡号"
        maxlength="19"
        :rules="[{ required: true, message: '请填收款账号' },{ pattern:/^\d{16}|\d{16}-\d{4}|\d{4} \d{12}|\d{4} \d{7}$/, message: '收款账号格式错误' }]"
      />
      <van-field
        v-model="bankName"
        label="开户行"
        placeholder="请输入您的开户行"
        :rules="[{ required: true, message: '请输入您的开户行' }]"
      />

      <van-field
        v-model="phone"
        label="手机号"
        placeholder="银行卡手机号"
        maxlength="11"
        :rules="[{ required: true, message: '请填银行卡写手机号' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
      />
      <div v-if="!urlName">
        <!-- <div class="login_bottom">
          <van-checkbox v-model="checked" icon-size="15px" checked-color="#fc6e09">登录即代表同意</van-checkbox>
          <p @click="checkProtocol">《服务协议》</p>
        </div> -->
        <div class="login-button" v-if="!urlName">
          <van-button round block type="info" native-type="submit">{{buttonText}}</van-button>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast ,Dialog} from 'vant';
export default {
  data() {
    return {
      cardNumber: '',
      name: '',
      phone: '',
      IDcard: '',
      bankName: '',
      urlName: null,
      bankData: '',
      checked: '',
      buttonText:'提交'
    }
  },
  mounted() {
    // this.urlName = this.$route.query.account
    // if (this.urlName) {
    //   this.getData()
    // }
    this.getData()
  },
  methods: {
    validator(val) {
      const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
      const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      return card15.test(val) || card18.test(val)
    },
    onSubmit() {
      if(this.buttonText=='修改'){
        Dialog.confirm({
          title: '是否确认修改！！！',
        })
          .then(() => {
            this.isSubmit()
          })
          .catch(() => {
            // on cancel
          });
      }else{
        this.isSubmit()
      }
    },
    isSubmit(){
      let that = this
      let data = {
        userId: localStorage.getItem('userid'),
        accountName: that.name,
        bankCard: that.cardNumber,
        bankPhone: that.phone,
        idNo: that.IDcard,
        bankName: that.bankName//开户行
      }
      that.$fetchPost(URL.cardBinding.url, that.$toFormData(data)).then(res => {
        if (res.data.code == 20000) {
          Toast(res.data.msg)
          that.buttonText='修改'
          that.$router.go(-1)
        }
      })
    },
    getData() {
      let that = this
      let userId = localStorage.getItem('userid')
      that.$fetchGet(URL.myCard.url, { userId: userId }).then(res => {
        if(res.data.code=='20000'){
          that.cardNumber = res.data.data.bankCard
          that.phone = res.data.data.bankPhone
          that.name = res.data.data.accountName
          that.bankName = res.data.data.bankName//开户行
          that.IDcard=res.data.data.idNo
          if(that.cardNumber && that.phone && that.name && that.IDcard){
            that.buttonText='修改'
          }
        }
      })

    },
    checkProtocol() { }//协议
  }
}
</script>

<style lang="less" scoped>
.bank-bg {
  height: 100vh;
  background: #fff;
  .van-cell {
    width: 355.25px;
    margin: auto;
    padding: 0;
    line-height: 67.5px;
  }
}
.login_bottom {
  width: 200px;
  height: 15.5px;
  line-height: 15.5px;
  display: flex;
  font-size: 12px;
  margin: 136.5px auto auto 100px;
  // /deep/.van-checkbox__icon .van-icon {
  //   width: 15px;
  //   height: 15px;
  // }
  /deep/.van-checkbox__icon {
    height: 15.5px;
    line-height: 15.5px;
  }
  p {
    color: #fc6f0c;
  }
}
.login-button {
  width: 272.5px;
  height: 42px;
  margin: 34.5px auto 0 auto;

  .van-button {
    background: url("./../product/img/product_bg3.png") no-repeat 100%;
    background-size: 100% 100%;
    border: 0;
  }
}
</style>